import * as Yup from 'yup';
import { requiredIbanSchema } from 'shared/utils/ibanSchema';

/**
 * Validation d'une liste de comptes bancaires saisis à la création (facultative,
 * mais chaque ligne présente doit être complète) : IBAN valide (longueur et clé),
 * libellé requis. Partagée entre les formulaires de création (plateforme,
 * gestionnaire…).
 */
export const bankAccountsArraySchema = Yup.array().of(
  Yup.object().shape({
    iban: requiredIbanSchema,
    label: Yup.string().required('Le libellé est requis'),
    bic: Yup.string(),
    isDefault: Yup.boolean(),
  }),
);
